import { IGoalStrategy } from 'interfaces/redux/goal'
import { SET_GOAL_STRATEGIES, SET_VERSION } from 'redux/action/type'

interface IGoalState {
  strategies: IGoalStrategy[]
  versionSelected: ISelectItem
  versionOptions: ISelectItem[]
}

interface IGoalStrategiesAction {
  type: string
  data?: Partial<IGoalState>
}

const initState: IGoalState = {
  strategies: [],
  versionSelected: {
    value: '',
    label: '',
  },
  versionOptions: [],
}

const goalReducer = (
  state: IGoalState = initState,
  action: IGoalStrategiesAction,
) => {
  switch (action.type) {
    case SET_GOAL_STRATEGIES:
      return { ...state, ...action.data }
    case SET_VERSION:
      return { ...state, ...action.data }
    default:
      return state
  }
}

export default goalReducer
